export default __webpack_public_path__ + "static/iPhone-Horizontal-bf0e720f5af362bb19f6ebb6bea453ee.png";